var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _text, _path15, _text2, _path16, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#bfbfbf}.st8{fill:#fff}.st9{fill:#369;fill-opacity:.502}.st10{font-family:&apos;ArialMT&apos;}.st11{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M524.8 66.5c.8-3.5.2-6.9-1.7-10.2-1.8-3.1-4.6-5.1-8.3-6-1.1-.3-2.2-.5-3.3-.5-2.4 0-4.7.7-6.9 2-3.1 2-5.1 4.8-6 8.3-.8 2.9-.6 5.6.4 8.1.4.8.8 1.5 1.1 2.3 2 3 4.8 5 8.3 6 1.1.3 2.3.4 3.4.4 2.4 0 4.7-.6 6.8-1.9 3.2-2.1 5.2-4.9 6.2-8.5m-5.5-7.8c1.3 2.1 1.7 4.3 1.1 6.8-.6 2.4-2 4.2-4.1 5.5-1.5.9-3.1 1.3-4.7 1.3-.7.1-1.4 0-2.1-.2-2.4-.6-4.2-2-5.5-4.1-1.3-2.2-1.7-4.5-1.1-6.8.6-2.4 2-4.2 4.1-5.5 1.3-.9 2.9-1.4 4.6-1.4.7 0 1.4.1 2.2.3 2.3.6 4.1 2 5.5 4.1z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M525.8 66.8c.3-1.2.4-2.4.4-3.6 0-2.6-.7-5.1-2.1-7.3-2.1-3.4-5.1-5.6-9-6.6-1.1-.3-2.3-.4-3.4-.4-2.6 0-5.1.7-7.3 2.1-3.4 2-5.6 5-6.6 8.8-.3 1.1-.4 2.3-.4 3.6-.1 1.7.3 3.4.9 5.1.2.8.6 1.5 1.1 2.3 2 3.4 5 5.6 8.8 6.6 1.1.3 2.3.4 3.4.4 2.7-.1 5.2-.8 7.5-2.1 3.4-2.2 5.6-5.2 6.7-8.9m-1.5-3.5c-.1 1.1-.2 2.1-.4 3-.8 3.4-2.7 6-5.6 7.7-2.1 1.3-4.3 1.9-6.6 1.9-.9-.1-1.9-.2-3-.4-3.2-.8-5.8-2.7-7.7-5.6-.3-.6-.6-1.3-.9-2.1-.5-1.4-.8-2.8-.8-4.3-.1-1.1.1-2.1.4-3 .8-3.4 2.6-6 5.6-7.9 1.9-1.1 4.1-1.7 6.4-1.7 1-.1 2 .1 3 .4 3.3.9 5.9 2.8 7.7 5.6 1.2 1.9 1.9 4 1.9 6.4m-7.4 8.4c2.3-1.4 3.8-3.4 4.3-6 .3-.8.4-1.6.4-2.4 0-1.8-.5-3.5-1.5-5.1-1.4-2.3-3.5-3.8-6-4.5-.8-.2-1.6-.3-2.4-.2-1.8-.1-3.5.4-5.1 1.3-2.3 1.5-3.8 3.6-4.5 6.2-.1.8-.2 1.5-.2 2.3 0 1.9.4 3.6 1.3 5.3 1.4 2.3 3.5 3.8 6.2 4.5.8.1 1.5.2 2.3.2 1.8-.1 3.6-.6 5.2-1.6m2.8-8.4c.1.7 0 1.4-.2 2.1-.6 2.1-1.9 3.8-3.8 4.9-1.2.8-2.6 1.1-4.1 1.1-.6 0-1.2-.1-1.9-.2-2.1-.6-3.7-1.8-4.9-3.6-.8-1.3-1.1-2.8-1.1-4.3 0-.6.1-1.2.2-1.9.6-2.1 1.8-3.7 3.6-4.9 1.3-.8 2.7-1.1 4.1-1.1.7-.1 1.3 0 1.9.2 2.3.5 4 1.7 5.1 3.6.8 1.3 1.1 2.7 1.1 4.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 32.3405,
    cy: 407.6488,
    r: 6.25,
    gradientTransform: "matrix(1.8822 0 0 -1.8822 456.2602 844.7622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M527.4 73.3c-2.1-4.5-5.5-6.8-10.3-7-1.3 0-2.7.3-4 .8-6 3.1-8.1 7.8-6.2 14.3 2.1 4.5 5.6 6.9 10.3 7.1 1.4 0 2.7-.3 4-.8 6-3.1 8.1-7.9 6.2-14.4z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M529.2 77.4c0-1.5-.3-2.9-.8-4.3-2.3-4.9-6-7.5-11.3-7.7-1.4.1-2.8.4-4.1.9-5 2.1-7.6 5.8-7.7 11.1-.1 1.4.2 2.8.8 4.3 2.3 4.9 6 7.4 11.1 7.5 1.6.1 3-.2 4.3-.8 5-2.1 7.5-5.8 7.7-11m-2.7-3.7c.5 1.3.8 2.5.8 3.8-.1 4.3-2.3 7.3-6.4 9.2-1.3.6-2.5.8-3.8.8-4.3-.1-7.3-2.3-9.2-6.4-.6-1.2-.8-2.4-.8-3.6.1-4.5 2.3-7.6 6.4-9.4 1.3-.5 2.4-.8 3.6-.8 4.5.2 7.6 2.3 9.4 6.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 240.2683,
    x2: 277.7433,
    y1: 374.5256,
    y2: 388.4006,
    gradientTransform: "matrix(1.8822 0 0 -1.8822 42.1791 816.2462)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M493.1 84.6l8.7 52 66.6-25.8-28.8-44.2-46.5 18z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M569.9 111.1l-.8-.9L540 65.4l-.8.2-46.3 18.1-.8.4v.8l8.8 53.1 69-26.9m-30.6-43.3l27.7 42.4-64.5 25.1-8.3-50.1 45.1-17.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M419.5 107.7c.8-3.6.2-7.1-1.7-10.4-1.9-3.1-4.6-5.1-8.3-6-1.1-.3-2.3-.5-3.4-.5-2.4 0-4.6.7-6.8 2-3.2 1.9-5.3 4.8-6.2 8.5-.6 2.7-.4 5.3.6 7.9.4.8.8 1.5 1.1 2.3 1.9 3.1 4.7 5.1 8.3 6 1.2.3 2.4.4 3.5.5 2.4-.1 4.6-.7 6.7-2 3.2-2 5.2-4.7 6.2-8.3m-5.4-7.9c1.2 2.1 1.5 4.4.9 6.8-.6 2.4-1.9 4.2-4 5.5-1.4.9-3 1.3-4.7 1.3-.7.1-1.4 0-2.1-.2-2.4-.6-4.3-2-5.6-4.1-1.1-2.1-1.4-4.3-.9-6.8.6-2.4 1.9-4.2 4-5.5 1.5-.9 3.1-1.4 4.7-1.4.8 0 1.4.1 2.1.3 2.4.6 4.3 2 5.6 4.1z",
    className: "st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420.3 107.8c.4-1.1.6-2.3.6-3.6 0-2.5-.8-5-2.3-7.3-2-3.4-5-5.6-8.8-6.6-1.1-.2-2.3-.3-3.4-.4-2.7.1-5.2.8-7.5 2.1-3.3 2.1-5.5 5.1-6.4 8.8-.4 1.2-.6 2.4-.6 3.6 0 1.7.4 3.4 1.1 5.1.3.8.6 1.5.9 2.3 2.2 3.5 5.2 5.6 9 6.6 1.1.3 2.3.4 3.4.4 2.7 0 5.2-.7 7.5-2.1 3.5-2.1 5.6-5.1 6.5-8.9m-1.3-3.6c0 1.1-.1 2.1-.4 3-.9 3.4-2.8 6-5.6 7.9-2.1 1.1-4.3 1.7-6.6 1.7-1 .1-2-.1-3-.4-3.3-.8-5.9-2.7-7.7-5.6-.4-.6-.7-1.3-.9-1.9-.6-1.5-.9-3-.9-4.5.1-1.1.2-2.1.4-3 .9-3.4 2.8-6 5.6-7.7 2.1-1.3 4.3-1.9 6.6-1.9.9.1 1.9.2 3 .4 3.3.9 5.9 2.8 7.7 5.6 1.1 2.1 1.7 4.2 1.8 6.4m-7.5 8.7c2.4-1.5 3.9-3.6 4.5-6.2.3-.7.4-1.5.4-2.4 0-1.7-.5-3.4-1.5-5.1-1.4-2.3-3.5-3.8-6.2-4.5-.8-.1-1.5-.2-2.3-.2-1.9-.1-3.6.4-5.1 1.5-2.3 1.4-3.8 3.4-4.5 6-.2.8-.3 1.6-.4 2.4.1 1.8.6 3.5 1.5 5.1 1.4 2.3 3.5 3.8 6 4.5.9.2 1.8.3 2.4.2 2 0 3.7-.4 5.2-1.3m3-8.7c0 .7-.1 1.4-.4 2.1-.4 2.1-1.6 3.8-3.6 4.9-1.3.8-2.6 1.1-4.1 1.1-.6.1-1.3 0-1.9-.2-2.2-.6-3.8-1.8-4.9-3.6-.9-1.4-1.3-2.8-1.3-4.1.1-.7.2-1.4.4-2.1.4-2.1 1.6-3.7 3.6-4.9 1.3-.8 2.7-1.1 4.1-1.1.6 0 1.3.1 1.9.2 2.2.6 3.8 1.8 4.9 3.6.8 1.3 1.3 2.7 1.3 4.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 32.3405,
    cy: 407.6488,
    r: 7.35,
    gradientTransform: "matrix(1.8822 0 0 -1.8822 350.6695 883.7247)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.2 114.5c-2.1-4.5-5.6-6.9-10.4-7.1-1.3 0-2.6.2-3.9.7-6 3.1-8.1 7.8-6.2 14.3 2 4.5 5.4 6.8 10.1 7 1.4.1 2.7-.2 4-.8 6-2.8 8.1-7.5 6.4-14.1z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M423.9 118.6c0-1.6-.3-3-.9-4.3-2.1-4.9-5.8-7.5-11.1-7.7-1.3 0-2.8.3-4.3.9-4.8 2.1-7.3 5.8-7.5 11.1 0 1.4.3 2.8.8 4.3 2.3 4.8 6 7.3 11.1 7.5 1.6 0 3-.3 4.3-.8 4.8-2.2 7.4-5.9 7.6-11m-2.7-3.7c.4 1.3.7 2.5.8 3.8-.1 4.3-2.3 7.4-6.4 9.4-1.3.4-2.5.6-3.8.6-4.3-.2-7.4-2.3-9.4-6.4-.4-1.2-.6-2.4-.6-3.6.2-4.5 2.3-7.6 6.4-9.4 1.2-.4 2.4-.7 3.6-.8 4.5.1 7.6 2.2 9.4 6.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    x1: 184.5513,
    x2: 221.6513,
    y1: 352.205,
    y2: 367.08,
    gradientTransform: "matrix(1.8822 0 0 -1.8822 42.1791 816.2462)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.3 151.9l-28.8-44.2-46.5 18 8.7 52.1 66.6-25.9z",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M463.5 152.9l1.1-.6-29.7-45.7-.8.4-46.5 17.9-.6.4v.8l8.8 53.1 67.7-26.3M434.1 109l27.6 42.5-64.3 25-8.3-50.1 45-17.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M314.1 148.7c.9-3.6.4-7-1.5-10.2-2-3.1-4.8-5.2-8.3-6.2-1-.2-2-.3-3-.3-2.6 0-5 .7-7.2 2-3.2 1.9-5.3 4.6-6.2 8.3-.6 2.8-.4 5.5.6 8.1.3.6.6 1.3.9 2.1 2 3.2 4.8 5.2 8.5 6 1.1.3 2.2.5 3.3.5 2.4 0 4.7-.7 6.9-2 3.2-2 5.2-4.8 6-8.3m-5.4-7.9c1.3 2.2 1.7 4.5 1.1 6.8-.6 2.4-2 4.3-4.1 5.6-1.3.8-2.8 1.2-4.5 1.2-.7 0-1.4-.1-2.3-.3-2.3-.6-4.1-1.9-5.5-4.1-1.3-1.9-1.7-4.2-1.1-6.8.6-2.3 2-4.1 4.1-5.5 1.5-.9 3.1-1.3 4.7-1.3.8 0 1.4.1 2.1.2 2.4.7 4.2 2.1 5.5 4.2z",
    className: "st1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M315.1 148.9c.3-1.1.4-2.3.4-3.4.1-2.7-.6-5.2-2.1-7.5-2-3.3-5-5.5-8.8-6.6-1.1-.2-2.3-.3-3.4-.4-2.7 0-5.2.7-7.5 2.1-3.4 2.1-5.6 5.1-6.6 9-.2 1.1-.3 2.3-.4 3.4.1 1.8.4 3.5.9 5.1.4.9.8 1.7 1.1 2.3 2.2 3.4 5.1 5.6 8.8 6.6 1.3.3 2.5.4 3.6.4 2.6.1 5.1-.6 7.3-2.1 3.5-2.1 5.7-5 6.7-8.9m-1.5-3.4c.1.9-.1 1.9-.4 3-.8 3.2-2.7 5.8-5.6 7.7-1.9 1.1-4.1 1.7-6.4 1.7-1.1.1-2.1-.1-3-.4-3.3-.8-5.9-2.6-7.7-5.6-.4-.6-.7-1.3-.9-1.9-.6-1.5-.9-3-.9-4.5.1-1 .2-2 .4-3 .9-3.3 2.8-5.9 5.6-7.7 2.1-1.3 4.3-1.9 6.6-1.9.9.1 1.9.2 3 .4 3.2.8 5.8 2.7 7.7 5.6 1.1 2.1 1.6 4.3 1.6 6.6m-7.3 8.5c2.3-1.4 3.8-3.5 4.5-6.2.1-.8.2-1.5.2-2.3.1-1.9-.4-3.6-1.3-5.3-1.5-2.3-3.6-3.8-6.2-4.3-.8-.3-1.5-.4-2.3-.4-1.8 0-3.6.5-5.3 1.5-2.3 1.4-3.7 3.5-4.3 6-.3.8-.4 1.6-.4 2.4.1 1.8.6 3.5 1.5 5.1 1.4 2.4 3.5 3.9 6 4.5.8.1 1.6.2 2.4.2 1.9.1 3.6-.4 5.2-1.2m2.8-8.5c0 .6-.1 1.3-.2 1.9-.6 2.1-1.8 3.7-3.6 4.9-1.4.8-2.8 1.1-4.1 1.1-.7 0-1.3-.1-1.9-.2-2.3-.6-4-1.8-5.1-3.6-.8-1.3-1.1-2.7-1.1-4.1-.1-.8 0-1.4.2-1.9.6-2.1 1.9-3.8 3.8-5.1 1.2-.8 2.6-1.1 4.1-1.1.6-.1 1.2 0 1.9.2 2.1.6 3.8 1.8 4.9 3.8.7 1.1 1.1 2.5 1.1 4.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 32.3405,
    cy: 407.6488,
    r: 7.6,
    gradientTransform: "matrix(1.8822 0 0 -1.8822 242.5379 926.3576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 155.6c-1.9-4.5-5.3-6.8-10.1-7-1.4 0-2.7.3-4 .8-6 2.9-8.1 7.7-6.4 14.1 2.1 4.5 5.6 6.9 10.3 7.1 1.4 0 2.7-.3 4-.8 6-3 8.1-7.7 6.2-14.2z",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M318.5 159.6c0-1.4-.3-2.9-.8-4.3-2.3-4.8-6-7.3-11.1-7.5-1.6 0-3 .3-4.3.8-4.8 2.3-7.3 6-7.5 11.1-.1 1.4.2 2.9.8 4.3 2.3 4.9 6 7.4 11.1 7.5 1.4.1 2.9-.2 4.3-.8 4.8-2.2 7.3-5.9 7.5-11.1m-2.4-3.6c.4 1.2.6 2.4.6 3.6-.2 4.3-2.3 7.5-6.4 9.4-1.2.4-2.4.6-3.6.6-4.4-.2-7.5-2.3-9.4-6.4-.4-1.2-.6-2.4-.6-3.6.1-4.3 2.2-7.5 6.4-9.4 1.1-.4 2.3-.6 3.6-.6 4.2.2 7.4 2.3 9.4 6.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    x1: 128.5082,
    x2: 165.7082,
    y1: 330.6239,
    y2: 344.9239,
    gradientTransform: "matrix(1.8822 0 0 -1.8822 42.1791 816.2462)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.8 166.8l8.7 52.1 66.4-26-28.6-44.2-46.5 18.1z",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M359.4 193.5l-.6-1.1-28.8-44-.6-.8-.6.4-46.4 18-.8.2.2.8 8.8 53.3.9-.6 67.9-26.2m-30.6-43.6l27.8 42.7-64.4 24.8-8.3-50.1 44.9-17.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M647 246.3V104.2h-61.7L256.4 232.3H103.1v13.9H647z",
    className: "st1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M647 105.1v-1.9h-61.9L256.4 231.5v-.1H103.1v1.9h153.8l328.8-128.2H647z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M417.2 144.7l1.6-4.3-2.6 1.1-1.4 4.3-2.4-6.2-2.2.9 4.4 11.4 2.2-.9-1.1-2.6.5-1.3 3.4 2.8 2.6-1-5-4.2m2.2-20.1l-6.1 2.4 1.6 6.5 2-.6c0-.4.2-.8.5-1.1.2-.1.4-.2.7-.3.6-.2 1.1-.2 1.4.1.4.3.7.7.9 1.2.2.6.3 1.1.2 1.6-.2.5-.5.8-1.1 1.1-.5.2-.9.2-1.2 0-.4-.1-.7-.4-.9-.9l-2.2.9c.4 1.1 1.1 1.7 2 2 .9.3 1.9.2 3-.2 1.3-.5 2.1-1.3 2.5-2.4.3-1.1.3-2.1-.1-3.2-.4-1.2-1.1-2-2.1-2.3-.9-.4-1.8-.4-2.7-.1-.5.2-.9.4-1.1.7-.2.2-.4.4-.7.8l-.5-2.7 4.5-1.8-.6-1.7m9.5 22.6c-.1.6-.6 1.1-1.4 1.4-.6.2-1 .3-1.3.2-.2 0-.4-.2-.5-.5l-2.4.9c.4.8 1.1 1.3 2 1.5.8.2 1.7.1 2.8-.3 1.8-.7 2.8-1.7 3.1-2.9.1-.7 0-1.6-.5-2.7l-3.1-8-2.2.9.5 1.2c-.5-.4-1.1-.7-1.7-.7-.4 0-.7.1-1.2.3-1.1.4-1.8 1.2-2.1 2.3-.3 1.1-.2 2.3.3 3.5.5 1.3 1.3 2.2 2.2 2.8.9.5 1.9.6 3 .1.7-.3 1.2-.7 1.5-1.2.2-.3.4-.6.5-1.1l.2.5c.3.9.4 1.4.3 1.8m-1.7-5.3c.3.9.4 1.6.2 2.1s-.6.9-1.1 1.1c-.7.3-1.4.2-2-.5-.3-.3-.6-.7-.8-1.2-.2-.6-.3-1.1-.3-1.5 0-.8.3-1.4 1.1-1.7.5-.2 1.1-.2 1.6.1.5.3 1 .8 1.3 1.6zM315.8 181.8c-.3 1.1-.2 2.3.3 3.5.5 1.3 1.3 2.2 2.2 2.8.9.5 1.9.6 3 .1.7-.3 1.2-.7 1.5-1.2.2-.3.4-.6.5-1.1l.2.5c.3.8.4 1.4.4 1.8-.1.6-.6 1.1-1.4 1.4-.6.2-1 .3-1.3.2-.2 0-.4-.2-.5-.5l-2.4.9c.4.8 1.1 1.3 2 1.5.8.2 1.7.1 2.8-.3 1.8-.7 2.8-1.7 3.1-2.9.1-.7 0-1.6-.5-2.7l-3.1-8-2.2.9.5 1.2c-.5-.4-1.1-.7-1.7-.7-.4 0-.7.1-1.2.3-1.2.5-1.9 1.2-2.2 2.3m2.2 1.2c0-.8.3-1.4 1.1-1.7.5-.2 1.1-.2 1.6.1.5.3.9.9 1.2 1.6.3.9.4 1.6.2 2.1s-.6.9-1.1 1.1c-.7.3-1.4.2-2-.5-.3-.3-.6-.7-.8-1.2-.1-.6-.2-1.1-.2-1.5m-8.4 3.7l-2.4-6.2-2.2.9 4.4 11.4 2.2-.9-1.1-2.6.5-1.3 3.4 2.8 2.6-1-5.1-4.1 1.6-4.3-2.6 1.1-1.3 4.2m5.8-16.1c-.9-.4-1.8-.4-2.7-.1-.5.2-.9.4-1.1.7-.2.2-.4.4-.7.8l-.5-2.7 4.5-1.8-.7-1.8-6.1 2.4 1.6 6.5 2-.6c0-.4.2-.8.5-1.1.2-.1.4-.2.7-.3.6-.2 1.1-.2 1.4.1.4.3.7.7.9 1.2.2.6.3 1.1.2 1.6-.2.5-.5.8-1.1 1.1-.5.2-.9.2-1.2 0-.4-.1-.7-.4-.9-.9l-2.2.9c.4 1.1 1.1 1.7 2 2 .9.3 1.9.2 3-.2 1.3-.5 2.1-1.3 2.5-2.4.3-1.1.3-2.1-.1-3.2-.3-1.1-1-1.9-2-2.2zM517.8 98.4l-2.2.9 4.4 11.4 2.2-.9-1.1-2.6.5-1.3 3.4 2.8 2.6-1-5.1-4.1 1.6-4.3-2.6 1.1-1.4 4.3-2.3-6.3m7.7-13.1l-.7-1.8-6.1 2.4 1.6 6.5 2-.6c0-.4.2-.8.5-1.1.2-.1.4-.2.7-.3.6-.2 1.1-.2 1.4.1.4.3.7.7.9 1.2s.3 1.1.2 1.6c-.2.5-.5.8-1.1 1.1-.5.2-.9.2-1.2 0-.4-.1-.7-.4-.9-.9l-2.2.9c.4 1.1 1.1 1.7 2 2 .9.3 1.9.2 3-.2 1.3-.5 2.1-1.3 2.5-2.4.3-1.1.3-2.1-.1-3.2-.4-1.2-1.1-2-2.1-2.3-.9-.4-1.8-.4-2.7-.1-.5.2-.9.4-1.1.7-.2.2-.4.4-.7.8l-.5-2.7 4.6-1.7m10.6 18.5l-3.1-8-2.2.9.5 1.2c-.5-.4-1.1-.7-1.7-.7-.4 0-.7.1-1.2.3-1.1.4-1.8 1.2-2.1 2.3-.3 1.1-.2 2.3.3 3.5.5 1.3 1.2 2.2 2.2 2.8.9.5 1.9.6 3 .1.7-.3 1.2-.7 1.5-1.2.2-.3.4-.6.5-1.1l.2.5c.3.8.4 1.4.4 1.8-.1.6-.6 1.1-1.4 1.4-.6.2-1 .3-1.3.2-.2 0-.4-.2-.5-.5l-2.4.9c.4.8 1.1 1.3 2 1.5.8.2 1.7.1 2.8-.3 1.8-.7 2.8-1.7 3.1-2.9 0-.7-.1-1.6-.6-2.7m-4.8-4.6c.5.3.9.9 1.3 1.6.3.9.4 1.6.2 2.1s-.6.9-1.1 1.1c-.7.3-1.4.2-2-.5-.3-.3-.6-.7-.8-1.2-.2-.6-.3-1.1-.3-1.5 0-.8.3-1.4 1.1-1.7.5-.2 1-.2 1.6.1z",
    className: "st8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M345.6 211.7c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st9"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st8 st10 st11",
    transform: "matrix(.9981 0 0 1 333.1172 225.2681)"
  }, "\n    1\n  ")), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M554 132.2c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st9"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st10 st11",
    transform: "matrix(.9981 0 0 1 541.4668 145.7681)"
  }, "\n    3\n  ")), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M451.5 171.4c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st9"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st10 st11",
    transform: "matrix(.9981 0 0 1 439.0176 184.9678)"
  }, "\n    2\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem21);
export default __webpack_public_path__ + "static/media/item21.fe7ac3a6171798f02a05dae09f33af0a.svg";
export { ForwardRef as ReactComponent };